export interface SellingCompanyCountry {
  id: string;
  sellingCompanyId: string;
  sellingCompanyKey: string;
  sellingCompanyName: string;
  countryId: string;
  countryCode: string;
  countryName: string;
  countryVatRegNo: string;
  countryEoriNo: string;
  invoiceNotes: string;
}
